

// Get all dropdown trigger elements
const dropdownTriggers = [
    document.getElementById('dd_1'),
    document.getElementById('dd_2'), 
    document.getElementById('dd_3'),
    document.getElementById('dd_4')
];

// Get their corresponding dropdown menus (assuming they're the next sibling elements)
const dropdownMenus = dropdownTriggers.map(trigger => trigger.nextElementSibling);

// Initialize all dropdowns to be hidden
dropdownMenus.forEach(menu => {
    gsap.set(menu, {
        height: 0,
        opacity: 0,
        display: 'none'
    });
});

// Keep track of currently open dropdown
let currentOpenMenu = null;

// Function to handle dropdown animation
function animateDropdown(menuToOpen) {
    if (currentOpenMenu === menuToOpen) return;
    
    // If there's already an open menu, close it first
    if (currentOpenMenu) {
        gsap.to(currentOpenMenu, {
            height: 0,
            opacity: 0,
            duration: 0.3,
            ease: "power2.inOut",
            onComplete: () => {
                gsap.set(currentOpenMenu, { display: 'none' });
            }
        });
    }
    
    if (menuToOpen) {
        // Show the menu first to measure its height
        gsap.set(menuToOpen, { 
            display: 'block',
            height: 'auto',
            opacity: 0
        });
        
        // Get the natural height
        const height = menuToOpen.offsetHeight;
        
        // Set it back to 0 before animating
        gsap.set(menuToOpen, { height: 0 });
        
        // Animate to full height
        gsap.to(menuToOpen, {
            height: height,
            opacity: 1,
            duration: 0.3,
            ease: "power2.inOut"
        });
    }
    
    currentOpenMenu = menuToOpen;
}

// Add event listeners to all triggers
dropdownTriggers.forEach((trigger, index) => {
    trigger.addEventListener('mouseenter', () => {
        animateDropdown(dropdownMenus[index]);
    });
});

// Add event listener to the navbar to handle mouse leaving
const navbar = dropdownTriggers[0].parentElement;
navbar.addEventListener('mouseleave', () => {
    animateDropdown(null);
});
z